/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * item object
 * @export
 * @interface PostCharactersCharacterIdFittingsItem
 */
export interface PostCharactersCharacterIdFittingsItem {
    /**
     * Fitting location for the item. Entries placed in 'Invalid' will be discarded. If this leaves the fitting with nothing, it will cause an error.
     * @type {string}
     * @memberof PostCharactersCharacterIdFittingsItem
     */
    flag: PostCharactersCharacterIdFittingsItemFlagEnum;
    /**
     * quantity integer
     * @type {number}
     * @memberof PostCharactersCharacterIdFittingsItem
     */
    quantity: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof PostCharactersCharacterIdFittingsItem
     */
    typeId: number;
}


/**
 * @export
 */
export const PostCharactersCharacterIdFittingsItemFlagEnum = {
    Cargo: 'Cargo',
    DroneBay: 'DroneBay',
    FighterBay: 'FighterBay',
    HiSlot0: 'HiSlot0',
    HiSlot1: 'HiSlot1',
    HiSlot2: 'HiSlot2',
    HiSlot3: 'HiSlot3',
    HiSlot4: 'HiSlot4',
    HiSlot5: 'HiSlot5',
    HiSlot6: 'HiSlot6',
    HiSlot7: 'HiSlot7',
    Invalid: 'Invalid',
    LoSlot0: 'LoSlot0',
    LoSlot1: 'LoSlot1',
    LoSlot2: 'LoSlot2',
    LoSlot3: 'LoSlot3',
    LoSlot4: 'LoSlot4',
    LoSlot5: 'LoSlot5',
    LoSlot6: 'LoSlot6',
    LoSlot7: 'LoSlot7',
    MedSlot0: 'MedSlot0',
    MedSlot1: 'MedSlot1',
    MedSlot2: 'MedSlot2',
    MedSlot3: 'MedSlot3',
    MedSlot4: 'MedSlot4',
    MedSlot5: 'MedSlot5',
    MedSlot6: 'MedSlot6',
    MedSlot7: 'MedSlot7',
    RigSlot0: 'RigSlot0',
    RigSlot1: 'RigSlot1',
    RigSlot2: 'RigSlot2',
    ServiceSlot0: 'ServiceSlot0',
    ServiceSlot1: 'ServiceSlot1',
    ServiceSlot2: 'ServiceSlot2',
    ServiceSlot3: 'ServiceSlot3',
    ServiceSlot4: 'ServiceSlot4',
    ServiceSlot5: 'ServiceSlot5',
    ServiceSlot6: 'ServiceSlot6',
    ServiceSlot7: 'ServiceSlot7',
    SubSystemSlot0: 'SubSystemSlot0',
    SubSystemSlot1: 'SubSystemSlot1',
    SubSystemSlot2: 'SubSystemSlot2',
    SubSystemSlot3: 'SubSystemSlot3'
} as const;
export type PostCharactersCharacterIdFittingsItemFlagEnum = typeof PostCharactersCharacterIdFittingsItemFlagEnum[keyof typeof PostCharactersCharacterIdFittingsItemFlagEnum];


/**
 * Check if a given object implements the PostCharactersCharacterIdFittingsItem interface.
 */
export function instanceOfPostCharactersCharacterIdFittingsItem(value: object): value is PostCharactersCharacterIdFittingsItem {
    if (!('flag' in value) || value['flag'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function PostCharactersCharacterIdFittingsItemFromJSON(json: any): PostCharactersCharacterIdFittingsItem {
    return PostCharactersCharacterIdFittingsItemFromJSONTyped(json, false);
}

export function PostCharactersCharacterIdFittingsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCharactersCharacterIdFittingsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'flag': json['flag'],
        'quantity': json['quantity'],
        'typeId': json['type_id'],
    };
}

export function PostCharactersCharacterIdFittingsItemToJSON(json: any): PostCharactersCharacterIdFittingsItem {
    return PostCharactersCharacterIdFittingsItemToJSONTyped(json, false);
}

export function PostCharactersCharacterIdFittingsItemToJSONTyped(value?: PostCharactersCharacterIdFittingsItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flag': value['flag'],
        'quantity': value['quantity'],
        'type_id': value['typeId'],
    };
}

